import { render, staticRenderFns } from "./update-order-number.modal.vue?vue&type=template&id=8bbaa49a&"
import script from "./update-order-number.modal.vue?vue&type=script&lang=ts&"
export * from "./update-order-number.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports